export const politicasDoccuments = {
  desktop:{
    privacidade:'/documentos/vaidevoala_politicadeprivacidade.pdf',
    termoUso:'/documentos/vaidevoala_termosdeuso.pdf',
    cookies:'/documentos/vaidevoala_politicadecookies.pdf'
  },
  mobile:{
    privacidade:'/documentos/vaidevoala_politicadeprivacidade.pdf',
    termoUso:'/documentos/vaidevoala_termosdeuso.pdf'
  }
}
